import { SellerCenterSSOApiClient } from '@/apis';

export default {
  async singleSignOn () {
    const { data } = await SellerCenterSSOApiClient.get('solution-partner');

    return data;
  },
  async singleSignOnV2 (payload) {
    return SellerCenterSSOApiClient.post('solution-partners', payload);
  },
};
